// src/categories/sleep.js
const KEY = "sleep";
const TITLE = "Circadian / Sleep Reset";

const SENSATIONS = [
  "EYE HEAVINESS",
  "SLOW BLINKS",
  "YAWNING",
  "TEMPERATURE DROP",
  "DROWSY MIND",
  "SLOWED REACTIONS",
  "SLEEPINESS WHILE RESTING",
  "EARTHY HEAVINESS",
  "BEDTIME WARMTH",
  "RAINBOW STRETCH",
];

const DISH_NAMES = {
  "EYE HEAVINESS": "Heavy Eyes",
  "SLOW BLINKS": "Slow Blinks",
  "YAWNING": "Yawning",
  "TEMPERATURE DROP": "Temp Drop",
  "DROWSY MIND": "Drowsy Mind",
  "SLOWED REACTIONS": "Slowed Reactions",
  "SLEEPINESS WHILE RESTING": "Rest Sleepiness",
  "EARTHY HEAVINESS": "Earthy Heaviness",
  "BEDTIME WARMTH": "Bed Warmth",
  "RAINBOW STRETCH": "Stretch",
};

const ENCOURAGEMENTS = {
  "EYE HEAVINESS": "Melatonin rising; your body is primed for sleep — honour the cue.",
  "SLOW BLINKS": "Natural eye closure during tiredness — dim lights and rest now.",
  "YAWNING": "Thermoregulating and brain cooling — good sign for sleep onset.",
  "TEMPERATURE DROP": "Core temp falling — your circadian rhythm is doing its job.",
  "DROWSY MIND": "Shift toward sleep-state; avoid screens to let it deepen.",
  "SLOWED REACTIONS": "Reaction speed slows as sleep pressure builds — safe to rest.",
  "SLEEPINESS WHILE RESTING": "Sleep drive rising — a sign your body needs restoration.",
  "EARTHY HEAVINESS": "Muscle release for sleep — relax and let go.",
  "BEDTIME WARMTH": "Warming extremities help sleep onset — cosy is helpful.",
  "RAINBOW STRETCH": "Natural relaxation reflex preparing the body for rest.",
};

export default { KEY, TITLE, SENSATIONS, DISH_NAMES, ENCOURAGEMENTS };
